import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Download } from 'assets/svg/icon-download-cr.svg'

function IconDownload(props: IconProps): JSX.Element {
  const title = 'icon-download-cr'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Download {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconDownload
